import React from 'react';
import PropTypes from 'prop-types';
import { ClampText } from '@wix/wix-vod-shared/components';
import { WidgetScrollbarWrapper } from '../../scrollbar-wrapper/scrollbar-wrapper';
import ResizedImage from '../../resized-image/resized-image';
import styles from './channel-info-content.scss';
import { withTranslation } from '@wix/yoshi-flow-editor';

const COVER_IMAGE_SIZE = {
  width: 624,
  height: 310,
};

class ChannelInfoContent extends React.Component {
  static propTypes = {
    channelData: PropTypes.object,
  };

  get description() {
    const { description } = this.props.channelData;

    if (!description) {
      return null;
    }

    return (
      <div className={styles['description-wrapper']}>
        <WidgetScrollbarWrapper className={styles.scrollbar}>
          <div
            className={styles.description}
            data-hook="widget-channel-description"
          >
            {description}
          </div>
        </WidgetScrollbarWrapper>
      </div>
    );
  }

  render() {
    const { channelData, t } = this.props;
    const { title, coverUrl, customCoverUrl, videosCount } = channelData;

    return (
      <div className={styles.container}>
        <div className={styles['cover-overlay']} style={COVER_IMAGE_SIZE} />
        <ResizedImage
          src={customCoverUrl || coverUrl}
          width={COVER_IMAGE_SIZE.width}
          height={COVER_IMAGE_SIZE.height}
        />
        <div className={styles.content} id="widget-channel-info">
          <ClampText
            className={styles['channel-title']}
            dataHook="widget-channel-title"
            wrapperTag="h1"
            text={title}
          />
          <div
            className={styles['videos-count']}
            data-hook="widget-channel-videos-count"
          >
            {t('shared.videosCount', { videosCount })}
          </div>
          {this.description}
        </div>
      </div>
    );
  }
}

export default withTranslation()(ChannelInfoContent);
